import React, { useEffect, useState } from 'react';

const RenderHtml = ({ url }: any) => {

  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    const fetchHTML = async () => {
      try {
        const response = await fetch(url);
        if (response.ok) {
          const html = await response.text();
          setHtmlContent(html)
        }
      } catch (error) {
        console.error('Error fetching HTML:', error);
      }
    };
    fetchHTML();
  }, []);

  const [styles, setStyles] = useState({ background: '', color: '' });

  useEffect(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const divElement = doc.getElementById('html-element');

    if (divElement) {
      const background = divElement.style.background;
      const color = divElement.style.color;
      setStyles({ background, color });
    }
  }, [htmlContent]);

  const createHTMLContent = () => {
    return `
      <html>
        <head>
          <meta name="viewport" content="user-scalable=1.0,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0"/>
          <style>
            #html-element {
              background: ${styles.background};
              color: ${styles.color || "#ffffff"};
              width: 100%;
              word-wrap: break-word;
              min-height: 100px;
            }
          </style>
        </head>
        <body>
          <div id='html-element'>
            ${htmlContent}
          </div>
        </body>
      </html>
    `;
  };


  return (
    <div dangerouslySetInnerHTML={{ __html: createHTMLContent() }} />
  );
};

export default RenderHtml